import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  section: {
    marginTop: theme.spacing(4),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: '#172024',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    minWidth: 0,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    borderBottom: '1px solid #E0E0E0',
  },
  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  iconCircle: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: '#EBF0F2',
    color: '#172024',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
  cardTitle: {
    color: '#172024',
  },
  cardAction: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  list: {
    padding: theme.spacing(0.5, 0),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.75, 3),
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.02)',
    },
  },
  rowMain: {
    minWidth: 0,
    flex: '1 1 auto',
  },
  rowName: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#172024',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: 0,
    marginBottom: 2,
  },
  unreadDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.blue.main,
    flexShrink: 0,
  },
  rowMeta: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
    margin: 0,
  },
  rowTime: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    margin: 0,
  },
  rowTrailing: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    minWidth: 88,
  },
  replyButton: {
    minWidth: 88,
    borderRadius: 20,
    fontWeight: 500,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  emptyList: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '18px',
  },
  loading: {
    margin: theme.spacing(3),
  },
}))

export default useStyles
